import { NgModule } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';
import { AGGRID_LICENSE } from './global-licenses.constants';

@NgModule({
    imports: []
})
export class GlobalLicensesModule {
    constructor() {
        LicenseManager.setLicenseKey(AGGRID_LICENSE);
    }
}
